// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1329bfcf] .proposal-documents__element .document-info {\n  background-color: #F7F7F7;\n  margin-bottom: 2rem;\n}", ""]);
// Exports
module.exports = exports;
